import { channelsInstance } from '@/api/instances'
import { CHANNEL_KINDS, ChannelStatus } from '@/models/channels'
import DatabaseFactory from '@/wrappers/database'

const fetchMemberChannels = async (
  { state, commit, dispatch },
  { personId, status = [ChannelStatus.ACTIVE, ChannelStatus.ARCHIVED] }
) => {
  let notLoaded = true
  if (state.memberChannels.length) {
    notLoaded = state.memberChannels.some(
      channel => channel.personId !== personId
    )
  }

  if (!notLoaded) return
  commit('setMemberChannels', [])

  try {
    const baseUrl = `persons/${personId}/channels?status=${status.join(',')}`

    const channels = await channelsInstance.get(baseUrl)

    commit('setMemberChannels', channels)
  } catch (error) {
    dispatch(
      'errors/setError',
      { error, request: 'pillars/channel/member/fetchChannels' },
      { root: true }
    )
  }
}

/**
 * Get only active channels and update memberChannels with archived channels in store
 * @param {*} store
 * @param {*} channelPersonId
 */
const fetchUpdatedActiveChannels = async (store, personId) => {
  try {
    const baseUrl = `persons/${personId}/channels?status=${ChannelStatus.ACTIVE}`

    const channels = await channelsInstance.get(baseUrl)

    store.commit('updateActiveChannels', channels)
  } catch (error) {
    store.dispatch(
      'errors/setError',
      { error, request: 'pillars/channel/member/fetchActiveChannels' },
      { root: true }
    )
  }
}

const fetchChannelsByStaff = async (store, { memberId }) => {
  store.commit('setChannelsWithStaff', undefined)

  const staffId = store.rootGetters['user/user'].id

  const database = new DatabaseFactory('channels').getReadDatabase()
  const query = {
    filters: [
      { field: 'kind', condition: '==', value: CHANNEL_KINDS.CHANNEL },
      { field: 'status', condition: '==', value: ChannelStatus.ACTIVE },
      { field: `staff.${staffId}.id`, condition: '==', value: staffId },
      { field: 'personId', condition: '==', value: memberId }
    ]
  }

  const channels = await database.get(query)

  store.commit('setChannelsWithStaff', channels)
}

const clearChannelsByStaff = store => {
  store.commit('setChannelsWithStaff', undefined)
}

const clearState = store => {
  store.commit('setChannelsWithStaff', undefined)
  store.commit('setMemberChannels', [])
}

export default {
  fetchMemberChannels,
  fetchChannelsByStaff,
  clearChannelsByStaff,
  fetchUpdatedActiveChannels,
  clearState
}
